import { render, staticRenderFns } from "./d_inventory.vue?vue&type=template&id=3fcdcd8a&"
import script from "./d_inventory.vue?vue&type=script&lang=js&"
export * from "./d_inventory.vue?vue&type=script&lang=js&"
import style0 from "./d_inventory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports